import styled from 'styled-components';
import { IStyle } from './types';

export const Overlay = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  flex: 1;
`;
export const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const ModalContent = styled.div`
  display: flex;
  background: #fff;
  padding: 10px;
  border-radius: 12px;
  width: 60%;
  gap: 20px;
  height: 500px;
  position: relative;
  position: fixed;
  justify-content: space-between;
  max-width: 1000px;
`;

export const ContentGift = styled.div`
  width: 48%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonClose = styled.button`
  display: flex;
  gap: 5px;
  align-items: center;
  border: none;
  outline: none;
  background: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  position: absolute;
  left: 10px;
  top: 10px;
`;

export const ContentText = styled.div`
  width: 50%;
  background: rgba(183, 255, 189, 0.3);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`;

export const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Title = styled.p`
  color: #226a43;
  font-weight: 700;
  font-size: 38px;
  margin: 0;
`;

export const Button = styled.button`
  margin: 0;
  border-radius: 18px;
  background: #005f47;
  padding: 20px;
  color: #fff;
  font-weight: 700;
  width: 100%;
  font-size: 18px;
`;

export const WrapperTexts = styled.p`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;
export const Quest = styled.p`
  color: #1e1e1e;
  font-weight: 700;
  font-size: 26px;
  margin: 0;
`;
export const Describe = styled.p`
  color: #1e1e1e;
  font-weight: 400;
  font-size: 18px;
  margin: 0;
`;
